export default __webpack_public_path__ + "static/media/totalCollections.da45d0f9.svg";